"use strict";

var _classCallCheck = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var proxiedWindowEventHandlers = require("../helpers/proxied-window-event-handlers");

var HTMLBodyElementImpl = /*#__PURE__*/function (_HTMLElementImpl) {
  _inherits(HTMLBodyElementImpl, _HTMLElementImpl);

  function HTMLBodyElementImpl() {
    _classCallCheck(this, HTMLBodyElementImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(HTMLBodyElementImpl).apply(this, arguments));
  }

  return HTMLBodyElementImpl;
}(HTMLElementImpl);

var _iteratorNormalCompletion = true;
var _didIteratorError = false;
var _iteratorError = undefined;

try {
  var _loop = function _loop() {
    var name = _step.value;
    Object.defineProperty(HTMLBodyElementImpl.prototype, name, {
      configurable: true,
      enumerable: true,
      get: function get() {
        var window = this._ownerDocument._defaultView;
        return window ? window[name] : null;
      },
      set: function set(handler) {
        var window = this._ownerDocument._defaultView;

        if (window) {
          window[name] = handler;
        }
      }
    });
  };

  for (var _iterator = proxiedWindowEventHandlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
    _loop();
  }
} catch (err) {
  _didIteratorError = true;
  _iteratorError = err;
} finally {
  try {
    if (!_iteratorNormalCompletion && _iterator.return != null) {
      _iterator.return();
    }
  } finally {
    if (_didIteratorError) {
      throw _iteratorError;
    }
  }
}

module.exports = {
  implementation: HTMLBodyElementImpl
};